import { render, staticRenderFns } from "./dicToolManage.vue?vue&type=template&id=8d927e48"
import script from "./dicToolManage.vue?vue&type=script&lang=js"
export * from "./dicToolManage.vue?vue&type=script&lang=js"
import style0 from "./dicToolManage.vue?vue&type=style&index=0&id=8d927e48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports